export default "__VITE_ASSET__2a2ea16e__"